import { FunctionComponent } from 'react';
import { useDispatch, useSelector } from '@cbridge-utils/react-redux';
import { IFilterItemRendererProps, FilterBlockItemBase } from '@cbridge-tools/filters-panel';
import { SymbolGroupsAction } from '@cbridge-packages/symbol-groups';
import { coreSymbolGroupPropsSelector } from './CoreSymbolGroup.selector';

export const CoreSymbolGroup: FunctionComponent<IFilterItemRendererProps> = (props) => {
  const { item, depth } = props;
  const { value } = item;

  const isSelected = useSelector(coreSymbolGroupPropsSelector, { symbolGroup: value as string });
  const dispatch = useDispatch();

  const handleClick = () => {
    dispatch(SymbolGroupsAction.toggleSelect({ symbolGroup: value as string }));
  };

  return (
    <FilterBlockItemBase
      item={item}
      depth={depth}
      isSelected={isSelected}
      onClick={handleClick}
    />
  );
};
